import { MetricService } from "app/services/metric/MetricService";
import { MetricUtil } from "app/services/metric/MetricUtil";
import React, { useEffect, useState } from "react";
import { Metric, ReachMetric } from "../../../components/metrics/ReachMetric";
import { useDataReport } from "../../../DataReportProvider";
import { metrics } from "app/utils/data/metrics";
import { updateLoadedMetrics } from "app/store/reducers/metric_reducer";
import { useDispatch } from "react-redux";
import { getLoadedMetricById } from "app/utils/utils";

const ReachNewsletter: React.FC = () => {

    const [newslettersDelivered, setNewslettersDelivered] = useState<Metric[] | null>(null)
    const [sentCampaigns, setSentCampaigns] = useState<Metric[] | null>(null)
    const [avgBounceRate, setAvgBounceRate] = useState<Metric[] | null>(null)
    
    const dataReport = useDataReport()
    const dispatch = useDispatch();

    const getNewslettersDelivered = async (modifiedParams: any) => {
        let response = (await (new MetricService()).getMetricData(modifiedParams, metrics.newsletterDelivered.endpoint)).getResponseData();
        if (response.success === true) {
            setNewslettersDelivered(response.data);
            dispatch(updateLoadedMetrics({id: metrics.newsletterDelivered.id, data: response.data}));
        }
    }

    const getSentCampaigns = async (modifiedParams: any) => {
        let response = (await (new MetricService()).getMetricData(modifiedParams, metrics.campaignsSent.endpoint)).getResponseData();
        if (response.success === true) {
            setSentCampaigns(response.data);
            dispatch(updateLoadedMetrics({id: metrics.campaignsSent.id, data: response.data}));
        }
    }

    const getAvgBounceRate = async (modifiedParams: any) => {
        let response = (await (new MetricService()).getMetricData(modifiedParams, metrics.avgBounceRate.endpoint)).getResponseData();
        if (response.success === true) {
            setAvgBounceRate(response.data);
            dispatch(updateLoadedMetrics({id: metrics.avgBounceRate.id, data: response.data}));
        }
    }

    /** 
     * To calculate amount and percent of latest "n" periods, we need to modify date filtered before 
     * make request. We need to do that because the widget needs to retrive last 24
     * times periods before the requested date to calculate the amount 
    */
    const getMetrics = () => {

        const calculateStartDate = MetricUtil.calculateStartDate(dataReport.params.filter_filters.between_dates.from, dataReport.params.filter_filters.mode);

        const modifiedParams = {
            ...dataReport.params,
            filter_filters: {
                ...dataReport.params.filter_filters,
                between_dates: {
                    from: calculateStartDate,
                    to: dataReport.params.filter_filters.between_dates.to
                }
            }
        };

        let newsletter_delivered = getLoadedMetricById(metrics.newsletterDelivered.id);
        let sent_campaigns = getLoadedMetricById(metrics.campaignsSent.id);
        let avg_bounce_rate = getLoadedMetricById(metrics.avgBounceRate.id);

        if(newsletter_delivered !== null && newsletter_delivered !== undefined) {
            setNewslettersDelivered(newsletter_delivered);
        }else{
            getNewslettersDelivered(modifiedParams);
        }

        if(sent_campaigns !== null && sent_campaigns !== undefined) {
            setSentCampaigns(sent_campaigns);
        }else{
            getSentCampaigns(modifiedParams);
        }

        if(avg_bounce_rate !== null && avg_bounce_rate !== undefined) {
            setAvgBounceRate(avg_bounce_rate);
        }else{
            getAvgBounceRate(modifiedParams);
        }

    }

    const resetReports = () => {
        setNewslettersDelivered(null);
        setSentCampaigns(null);
        setAvgBounceRate(null);
    }


    useEffect(() => {
        resetReports();
        getMetrics();
    }, [dataReport.params])


    return (
        <>
            <div className='row g-5 g-xl-8' style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
                <div className="col-xl-12">
                    <hr></hr>
                </div>
                {/* begin::Col */}
                <div className='col-xl-6 flex-xl-fill mt-0'>
                    <ReachMetric
                        logo_image={'/media/svg/metric_icons/'+metrics.newsletterDelivered.logo}
                        snapshotId={metrics.newsletterDelivered.id}
                        title={metrics.newsletterDelivered.title}
                        subtitle={metrics.newsletterDelivered.subtitle}
                        startPeriod={24}
                        metrics={newslettersDelivered}
                        className='card-xl-stretch mb-xl-8'
                        chartColor='primary'
                        chartHeight='250px'
                        snapshotSwitch={true}
                    />
                </div>
                {/* end::Col */}
                {/* begin::Col */}
                <div className='col-xl-6 flex-xl-fill mt-0'>
                    <ReachMetric
                        logo_image={'/media/svg/metric_icons/'+metrics.campaignsSent.logo}
                        snapshotId={metrics.campaignsSent.id}
                        title={metrics.campaignsSent.title}
                        subtitle={metrics.campaignsSent.subtitle}
                        startPeriod={24}
                        metrics={sentCampaigns}
                        className='card-xl-stretch mb-xl-8'
                        chartColor='primary'
                        chartHeight='250px'
                        snapshotSwitch={true}
                    />
                </div>
                {/* end::Col */}
                {/* begin::Col */}
                {/* 
                <div className='col-xl-6 flex-xl-fill mt-0'>
                    <ReachMetric
                        logo_image='/media/svg/brand-logos/google-icon.svg'
                        snapshotId={metrics.totalHCPs.id}
                        title={metrics.totalHCPs.title}
                        subtitle={metrics.totalHCPs.subtitle}
                        startPeriod={24}
                        metrics={newslettersDelivered}
                        className='card-xl-stretch mb-xl-8'
                        chartColor='primary'
                        chartHeight='250px'
                    />
                </div>
                */}
                {/* end::Col */}
                {/* begin::Col */}
                <div className='col-xl-6 flex-xl-fill mt-0'>
                    <ReachMetric
                        logo_image={'/media/svg/metric_icons/'+metrics.avgBounceRate.logo}
                        snapshotId={metrics.avgBounceRate.id}
                        title={metrics.avgBounceRate.title}
                        subtitle={metrics.avgBounceRate.subtitle}
                        startPeriod={24}
                        metrics={avgBounceRate}
                        className='card-xl-stretch mb-xl-8'
                        chartColor='primary'
                        chartHeight='250px'
                        snapshotSwitch={true}
                        valueType='percent'
                    />
                </div>
                {/* end::Col */}
            </div>
        </>
    )
}


export default ReachNewsletter;